module.exports = __webpack_public_path__ + "static/media/person.bfc8e3a7.svg";